import Box from "@mui/material/Box";
import { Alert } from "@andorhealth/clientuireact.designsystem";

export function Toast({
  tone,
  message,
  onClose,
}: {
  tone: "success" | "error";
  message: string;
  onClose: () => void;
}) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 24,
        right: 24,
        width: { xs: "calc(100% - 48px)", sm: 420 },
        zIndex: 1400,
      }}
    >
      <Alert type={tone} title={message} onClose={onClose} />
    </Box>
  );
}
